// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"422":"5ffa8edc","485":"5ffa8edc","501":"9c581e0a","509":"5ffa8edc","536":"835d2211","997":"5ffa8edc"}[chunkId] + ".chunk.css";
};